<app-modal-container
  cardBodyClass="px-4 py-2"
  [backdropClose]="!isLoading"
  [displayXButton]="!isLoading"
  [displayFooter]="!isLoading"
>
  <div class="modal-header-content">
    {{ 'migration_troubleshooting' | translate }}
  </div>

  <div class="modal-body-content max-modal-width">
    @switch (state) {
      @case (State.info) {
        <p class="body-content-heading">
          {{ 'does_it_seem_like_the_workspace_migration_has_caused_some_problems' | translate }}
        </p>
        <span [innerHTML]="'workspace_migration_troubleshooting_explanation' | translateHtml"></span>
      }
      @case (State.error) {
        <p class="body-content-heading">
          {{ 'does_it_seem_like_the_workspace_migration_has_caused_some_problems' | translate }}
        </p>
        <span [innerHTML]="'workspace_migration_troubleshooting_explanation' | translateHtml"></span>
        <div class="alert w-100 alert-danger my-3">{{ 'workspace_migration_troubleshooting_error' | translate }}</div>
      }
      @case (State.loading) {
        <div class="spinner-info-container flex-column align-items-center">
          <p class="spinner-header body-content-heading mt-3">{{ 'resync_in_progress' | translate }}</p>
          <div class="spinner-border my-3"></div>
          <span class="spinner-description my-5">{{ 'workspace_migration_troubleshooting_loading' | translate }}</span>
        </div>
      }
      @case (State.success) {
        <div class="spinner-info-container flex-column align-items-center">
          <p class="body-content-heading spinner-header mt-3">{{ 'resync_is_complete' | translate }}</p>
          <div class="spinner-check-container">
            <svg><use xlink:href="#check"></use></svg>
          </div>
          <span class="spinner-description my-3">{{ 'workspace_migration_troubleshooting_success' | translate }}</span>
        </div>
      }
    }
  </div>

  <div class="modal-footer-content">
    <div class="row justify-content-between">
      @if (state === State.success) {
        <div class="col-auto">
          <button class="btn btn-outline-primary font-weight-500" (click)="close()">
            {{ 'label_close' | translate }}
          </button>
        </div>
      } @else {
        <div class="col-auto">
          <button class="btn btn-outline-primary font-weight-500" (click)="close()">
            {{ 'form_cancel' | translate }}
          </button>
        </div>
        <div class="col-auto">
          <button class="btn btn-primary font-weight-500" (click)="resync()">
            {{ 'start_resync' | translate }}
          </button>
        </div>
      }
    </div>
  </div>
</app-modal-container>
